import { createRoot } from 'react-dom/client';
import { Locale, LocaleProvider } from '@op/opds.opux';
import { MessageProvider } from '@messageformat/react';
import App from './App';
import getMessages from './messages/getMessages';

const container = document.getElementById('investoracademy-root');
const root = createRoot(container!);

const startApp = async (): Promise<void> => {
  const locale = (document.documentElement.lang || 'fi').slice(0, 2) as Locale;
  const messages = await getMessages(locale);
  root.render(
    <LocaleProvider locale={locale}>
      <MessageProvider messages={messages}>
        <App />
      </MessageProvider>
    </LocaleProvider>,
  );
};

startApp();
